import React from "react";
import { constants } from "@qgiv/core-js";
import { useSelector } from "react-redux";
import { selectRegistrationAccount } from "../../../redux/slices/registrationAccountSlice";
import { selectHTTP } from "../../../redux/slices/configSlice";
import { formViews } from "../../common/AccountForm";
import AccountModalHeaderText from "./AccountModalHeaderText";
import { selectSpecificFormSetting } from "../../../redux/slices/formSettingsSlice";
import { selectAlias } from "../../../redux/slices/p2pSettingsSlice";

const ConnectedAccountModalHeaderText = () => {
    const HTTP_HOST = useSelector(selectHTTP);
    const registrationAccount = useSelector(selectRegistrationAccount);
    const {
        form: { formView, submitted },
        contact,
        resetPasswordLinkStatus = "",
    } = registrationAccount;

    const title = useSelector((state) =>
        selectSpecificFormSetting(state, "title"),
    );
    const alias = useSelector(selectAlias);

    const eventHomeUrl = `${HTTP_HOST}/event/${alias}/`;
    const {
        ENUMS: { Status },
    } = constants;

    // Consolidate all of the title and description logic for the modal
    const getAccountModalTitleAndDescription = () => {
        let accountModalTitle = "Sign In";
        // Link to the home page for the event that is present in the
        // description displayed on the sign in and the activate account screens
        const titleLink = (
            <>
                <br />
                <a href={eventHomeUrl} target="_blank" rel="noreferrer">
                    <strong className="account-modal-header__description-bold-theme">
                        {" "}
                        {title}
                    </strong>
                </a>
            </>
        );
        // Default description is the sign in screen
        let accountModalDescription = (
            <p>
                Sign in to your fundraising account for
                {titleLink}
            </p>
        );

        // Set title and description text
        if (formView === formViews.ACTIVATE_ACCOUNT) {
            accountModalTitle = `Hi, ${contact.firstName}! Create a password to get started.`;
            accountModalDescription = (
                <p>
                    Create a password to start fundraising for
                    {titleLink}
                </p>
            );
        } else if (
            formView === formViews.RESET_PASSWORD &&
            resetPasswordLinkStatus === Status.ACTIVE
        ) {
            accountModalTitle = "Reset Your Password";
            accountModalDescription = (
                <p>
                    Looks like you&apos;re having trouble signing in. No
                    worries! Just set a new password below.
                </p>
            );
        } else if (
            formView === formViews.RESET_PASSWORD &&
            resetPasswordLinkStatus === Status.USED
        ) {
            accountModalTitle = "Reset Your Password";
            accountModalDescription = (
                <p>
                    Shucks. It looks like you&apos;ve already used this link to
                    reset your password.
                </p>
            );
        } else if (
            formView === formViews.RESET_PASSWORD &&
            resetPasswordLinkStatus === Status.EXPIRED
        ) {
            accountModalTitle = "Reset Your Password";
            accountModalDescription = (
                <p>
                    Shucks. It looks like this link to reset your password has
                    expired.
                </p>
            );
        } else if (
            formView === formViews.SEND_RESET_PASSWORD_EMAIL_CONFIRMATION
        ) {
            accountModalTitle = "Help is on the way!";
            accountModalDescription = (
                <p>
                    We&apos;ve sent an email to{" "}
                    <strong>{submitted.Email}</strong> with a link to reset your
                    password so you can sign in to your account.
                </p>
            );
        }

        // Render function that is passed to the component that sets the
        // description that is displayed in the account modals
        const renderAccountModalDescription = () => accountModalDescription;

        return {
            accountModalTitle,
            renderAccountModalDescription,
        };
    };

    const { accountModalTitle, renderAccountModalDescription } =
        getAccountModalTitleAndDescription();

    const accountModalHeaderTextProps = {
        accountModalTitle,
        renderAccountModalDescription,
    };
    return <AccountModalHeaderText {...accountModalHeaderTextProps} />;
};

export default ConnectedAccountModalHeaderText;
